<template>
  <div>
    <v-toolbar color="primary" :dark="protocol.dark" fixed app>
      <v-toolbar-title center>Digital signering - BankID</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <v-layout wrap>
          <v-flex xs12>
            <v-card class="mx-auto">
              <v-card dark flat>
                <v-card-title class="pa-2" :class="signRequest.status == 'signed' || signRequest.status == 'packaged' ? 'success' : 'secondary'">
                  <v-progress-circular
                      v-if="signRequest.status != 'signed' && signRequest.status != 'packaged'"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  <v-avatar v-else>
                    <v-icon>mdi-check-outline</v-icon>
                  </v-avatar>
                  <h3 class="title font-weight-light text-xs-center grow">{{signRequest.name}}</h3>
                  <v-avatar>
                    <v-icon>mdi-cellphone-lock</v-icon>
                  </v-avatar>
                </v-card-title>
              </v-card>
              <v-card-text class="py-0" style="max-height: 300px; overflow-y: scroll;">
                <v-timeline align-top dense>
                  <template v-for="(item, index) in signRequest.logs.slice().reverse()">
                    <v-timeline-item
                      color="secondary"
                      :key="index+'1'"
                      :icon="index==0 ? 'mdi-checkbox-blank-circle' : null"
                      :small="index==0 ? false : true"
                    >
                      <v-layout pt-3>
                        <v-flex xs6 sm3>
                          <strong>{{formatDate(item.date)}}</strong>
                        </v-flex>
                        <v-flex>
                          <strong>{{item.name}}</strong>
                          <div class="caption">{{item.description}}</div>
                        </v-flex>
                      </v-layout>
                    </v-timeline-item>
                  </template>
                </v-timeline>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="mt-4"
            v-for="(signer, index) in signRequest.signers"
            :key="index+'signer'"
          >
            <v-card class="ml-1 mr-1">
              <v-card dark flat>
                <v-card-title
                  class="pa-2"
                  :class="signer.status == 'signed' ? 'success' : 'secondary'"
                >
                  <v-progress-circular
                      v-if="signer.status != 'signed'"
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  <v-avatar v-else>
                    <v-icon>mdi-check-outline</v-icon>
                  </v-avatar>
                  <h3 class="title font-weight-light text-xs-center grow">{{signer.name}}</h3>
                  <v-avatar>
                    <v-icon>mdi-account</v-icon>
                  </v-avatar>
                </v-card-title>
              </v-card>
              <v-card-text class="py-0" style="max-height: 300px; overflow-y: scroll;">
                <v-timeline align-top dense>
                  <template v-for="(item, index) in signer.logs.slice().reverse()">
                    <v-timeline-item 
                      color="secondary"
                      :key="index+'1'"
                      :icon="index==0 ? 'mdi-checkbox-blank-circle' : null"
                      :small="index==0 ? false : true"
                    >
                      <v-layout pt-3>
                        <v-flex xs6 sm3>
                          <strong>{{formatDate(item.date)}}</strong>
                        </v-flex>
                        <v-flex>
                          <strong>{{item.name}}</strong>
                          <div class="caption">{{item.description}}</div>
                        </v-flex>
                      </v-layout>
                    </v-timeline-item>
                  </template>
                </v-timeline>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["protocol", "signRequest"],
  mounted: function() {},
  methods: {
    formatDate(theDate) {
      const [date, time] = theDate.split(" ");
      const [year, month, day] = date.split(".");
      const [hour, minute, second] = time.split(":");
      return `${day}.${month} ${hour}:${minute}`;
    }
  }
};
</script>
